import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "no-tabs sent-geo-modal d-flex align-items-center justify-content-center custom-min-vh" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-xl-3 col-md-5 col-sm-6 form-container" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "error-msg" }
const _hoisted_7 = { class: "form-group mt-3" }
const _hoisted_8 = { class: "error-msg" }
const _hoisted_9 = { class: "text-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_vue_select = _resolveComponent("vue-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("label", null, "Przedział tygodniowy", -1)),
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.form.date_range,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.date_range) = $event)),
              locale: _ctx.datePickerLocale,
              "now-button-label": _ctx.$t('components.datepicker.nowText'),
              "partial-range": false,
              placeholder: _ctx.$t('components.datepicker.placeholder'),
              "auto-apply": "",
              format: "dd/MM/yyyy",
              "preview-format": "dd/MM/yyyy",
              required: true,
              range: { partialRange: false }
            }, null, 8, ["modelValue", "locale", "now-button-label", "placeholder"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.form.date_range.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                key: error.$uid,
                class: "vuelidate-errors"
              }, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("label", null, "Pojazd", -1)),
            _createVNode(_component_vue_select, {
              class: "vue-select",
              icon: "bi bi-truck",
              label: "label",
              clearable: true,
              options: _ctx.vehicles,
              value: _ctx.vehicles.find(i => String(i.id) === String(_ctx.form.vehicle_id)),
              onUpdateSelect: _ctx.emitVehicle
            }, null, 8, ["options", "value", "onUpdateSelect"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.form.vehicle_id.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                key: error.$uid,
                class: "vuelidate-errors"
              }, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn btn-success btn-search",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.generate && _ctx.generate(...args)))
            }, _toDisplayString(_ctx.$t('modules.forms.report.btn_generate')), 1)
          ])
        ])
      ])
    ])
  ]))
}